export const SCROLL_OFFSET = -90

export const navItems = [
    {to: 'main', label: 'Главная'},
    {to: 'skills', label: 'Навыки'},
    {to: 'projects', label: 'Проекты'},
    {to: 'hire', label: 'Нанять'},
    {to: 'contacts', label: 'Контакты'},
] as const
